<template>
    <div class="menu">
        <div class="menu-left">
            <div class="item">
                <i class="iconfont iconxiaoyuha"></i>
                <i class="iconfont icondian1"></i>
                <i class="iconfont icondian1"></i>
            </div>
            <div class="item process" v-for="(item,index) in menu" :key="index">
                <router-link :to="item.link" v-if="item.click">
                    <span :class="{active:$route.path === item.link}">
                        {{item.name}}
                    </span>
                </router-link>
                <a href="javascript:;" v-else>
                    <span :class="{active:$route.path === item.link}">
                        {{item.name}}
                    </span>
                </a>
                <i class="iconfont icondian1"></i>
                <i class="iconfont icondian1"></i>
            </div>
            <div class="item">
                <i class="iconfont iconxiaoyu"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "menu-list",
        data() {
            return {
                menu: [
                    {
                        name: '店铺设置',
                        link: '/MaritimeSilkRoad/registered-shops',
                        click:true
                    },
                    {
                        name: '选择模板',
                        link: '/MaritimeSilkRoad/selection',
                        click:true
                    },
                    {
                        name: '基础信息',
                        link: '/MaritimeSilkRoad/baseEdit',
                        click:false
                    },
                    {
                        name: '图片编辑',
                        link: '/MaritimeSilkRoad/imgEdit',
                        click:false
                    },
                    {
                        name: '价格设置',
                        link: '/MaritimeSilkRoad/priceEdit',
                        click:false
                    },
                    {
                        name: '物流设置',
                        link: '/MaritimeSilkRoad/logisticsEdit',
                        click:false
                    },
                    {
                        name: '商品管理',
                        link: '/MaritimeSilkRoad/product',
                        click:true
                    },
                    {
                        name: '个人设置',
                        link: '/MaritimeSilkRoad/personal',
                        click:true
                    },
                ],
                manage:[
                    {
                        name: '订单',
                        link: '/MaritimeSilkRoad/order'
                    },
                    {
                        name: '财务',
                        link: '/MaritimeSilkRoad/selection'
                    },
                    {
                        name: '客服',
                        link: '/MaritimeSilkRoad/service'
                    },
                ]
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        display: flex;
        justify-content: space-between;

        div.menu-left {
            height: 60px;
            background: #4149A9;
            box-shadow: 0px 20px 30px -16px #b7ccce;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 28px;
            padding: 0 26px;

            > .item {
                display: flex;
                align-items: center;
                color: black;

                &.process  span {
                    color: #ffffff;
                    &.active {
                        color: #FF65A5;
                    }

                    margin: 0 8px;
                }

                > i {
                    color: #ffffff;
                    font-size: 12px;
                    font-weight: bolder;
                    margin: 0 2px;
                }
            }
        }

        div.menu-right {
            height: 60px;
            background: #079BAB;
            box-shadow: 0px 20px 30px -16px #b7ccce;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 28px;
            color: #FFFFFF;
            font-size: 16px;
            padding: 0 20px;

            > .manage {
                display: flex;
                align-items: center;

                i {
                    margin: 0 10px 0 6px;
                    font-size: 20px;
                }

                > span {
                    width: 0;
                    height: 16px;
                    border-left: 2px solid #FFFFFF;
                    margin: 0 14px;
                }
            }

            > .item {
                span {
                    cursor: pointer;
                    padding: 9px 22px;
                    cursor: pointer;
                    color: #FFFFFF;

                    &.active, &:hover {
                        background: #FFFFFF;
                        border-radius: 10px;
                        color: #079BAB;
                    }
                }
            }
        }
    }
</style>
